export default {
  dbName: "serviforms",
  versionNumber: 9,
  schema: {
    formulario: "&,key,activity,companyId,companyName,groupId,groupName,method,uuid, name, version, formType, active",
    pages: "&,id_page,id_form,questions,key,total",
    // questions: '&,id_question,id_form,id_page,question_name,key',
    contadores: "&,id_form,contador,key",
    users:
      "&,access_token,address,cell_phone,city_id,city_name,company_id,company_name,email,expire_token,lastname,locale_id,locale_name,multiforms,name,role_id,role_name,status,username,uuid", //ID unique
    dependencias: "&,id_form,simple,dependencias,key, listener, compound"
  }
};
